// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiDataGrid-cell:focus {
    outline: none !important;
}

.MuiDataGrid-row {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/frontend/pages/prompts/prompt.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".MuiDataGrid-cell:focus {\n    outline: none !important;\n}\n\n.MuiDataGrid-row {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
